// extracted by css-extract-rspack-plugin
export default {"body":"body-Zl2i0x"};